(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orven-newsletter-popup"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('orven-newsletter')) {
  customElements.define('orven-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.ready) return;
      this.ready = true;
      const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
      const save = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
      const subscribed = document.querySelector('[data-orven-subscribed]');
      if (subscribed) save('orven-newsletter-subscribed', '1');
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('close', () => save('orven-newsletter-dismissed', String(Date.now())));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      if (subscribed) {
        if (location.hash.startsWith('#OrvenPopupNewsletter-') && !window.Shopify?.designMode) this.dialog.showModal();
        return;
      }
      if (window.Shopify?.designMode || read('orven-newsletter-subscribed') === '1') return;
      if (Date.now() - Number(read('orven-newsletter-dismissed') || 0) < 7 * 86400000) return;
      this.timer = setTimeout(() => {
        if (document.visibilityState === 'visible' && !document.querySelector('dialog[open]')) this.dialog.showModal();
      }, Number(this.dataset.delay || 12) * 1000);
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orven-tracking"]) return;
  try {
    

document.querySelectorAll('[data-orven-tracking]').forEach(form => {
  if (form.dataset.ready) return;
  form.dataset.ready = 'true';
  form.addEventListener('submit', event => {
    const input = form.querySelector('input[name="nums"]');
    const tracking = input.value.trim();
    if (!tracking) { event.preventDefault(); input.focus(); return; }
    event.preventDefault();
    window.location.assign('https://t.17track.net/en#nums=' + encodeURIComponent(tracking));
  });
});


  } catch(e) { console.error(e); }
})();
})();
